/*!
* # SeriouslyRAD
* http://www.seriouslyrad.com/
*
* Copyright (c) 2016 - 2024 Seriously RAD Limited - All Rights Reserved
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
*
*/

    "use strict";

    // User Notification
    classFactory.create({
        namespace: "seriouslyrad.plugins.notifications",
        name: "UserNotification",
        inherits: "seriouslyrad.ui.web.Card",
        properties: [
            { name: "targetUrl", type: "string" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this.addCssClass("rad-control-user-notification");

                // Trigger Property Changes
                this.targetUrlTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();

                    this.buttonDismiss.on("click", { self: this }, this.onButtonDismissClicked);
                    this.buttonOpen.on("click", { self: this }, this.onButtonOpenClicked);
                },
                _createElement: function ()
                {
                    this.super._createElement();

                    this.buttonDismiss =
                        new seriouslyrad.ui.web.Button({ cssClass: "rad-action-cancel", tag: "dismiss", text: "Dismiss" });

                    this.buttonOpen =
                        new seriouslyrad.ui.web.Button({ text: "Open", tag: "open" });
                },
                _targetUrlChanged: function (change)
                {
                    if (!String.isNullOrUndefinedOrWhitespace(change.currentValue))
                    {
                        this.buttonsSet([
                            this.buttonOpen,
                            this.buttonDismiss
                        ]);
                    }
                    else
                    {
                        this.buttonsSet([
                            this.buttonDismiss
                        ]);
                    }
                },

                // Event Handlers
                onButtonDismissClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self;

                    self.trigger("userNotificationButtonClicked", { button: self.buttonDismiss, notification: self });
                },
                onButtonOpenClicked: function (evt)
                {
                    evt.preventDefault();
                    evt.stopPropagation();

                    var
                        self = evt.data.self;

                    self.trigger("userNotificationButtonClicked", { button: self.buttonOpen, notification: self });
                }
            };
        }
    });

    // User Notification List
    classFactory.create({
        namespace: "seriouslyrad.plugins.notifications",
        name: "UserNotificationList",
        inherits: "seriouslyrad.ui.web.InfiniteScrollPanel",
        properties: [
            { name: "dialog" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                hasPreviousResults: false
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    this.super._bindEvents();
                    this.on("loadMore", { self: this }, this.onLoadMore);
                    this.on("userNotificationButtonClicked", { self: this }, this.onUserNotificationButtonClicked);
                },
                _createChildControls: function ()
                {
                    this.super._createChildControls();
                    this.cardList = new seriouslyrad.ui.web.CardList().appendTo(this);
                },
                _extendCardListAsync: function ()
                {
                    var
                        self = this,
                        lastCard = self.cardList.controlsGet().lastOrDefault(),
                        dataServiceData = {
                            lastReferenceNumber: lastCard ? lastCard.tagGet().referenceNumber : null,
                            pageSize: 10
                        };

                    return (
                        window.application.webApiClient
                            .createApiMethodRequest(
                                "DataService",
                                "CallDataService",
                                {
                                    id: "cc235279-29c2-4a76-b08a-71e574e614ee",
                                    operation: "ListUserNotifications",
                                    data: dataServiceData.toJson()
                                },
                                null,
                                false
                            )
                            .executeAsync()
                            .then(data =>
                            {
                                if (!data)
                                    return;

                                self.hasNextResultsSet(data.hasMoreResults);

                                data.results.forEach(item =>
                                {
                                    new seriouslyrad.plugins.notifications.UserNotification({
                                        tag: item,
                                        targetUrl: item.targetUrl,
                                        text: item.message,
                                        title: item.title,
                                        subtitle: item.createdDate ? Date.fromString(item.createdDate, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC().toString("dd/MM/yyyy HH:mm:ss") : null
                                    }).appendTo(self.cardList);
                                });
                            })
                    );
                },

                // Public Methods
                loadDataAsync: function ()
                {
                    this.cardList.controlsClear();
                    return this._extendCardListAsync();
                },

                // Event Handlers
                onLoadMore: function (evt, info)
                {
                    var
                        self = evt.data.self;

                    if (info.location === "top" && !self.hasPreviousResultsGet())
                        return;

                    if (info.location === "bottom" && !self.hasNextResultsGet())
                        return;

                    self._extendCardListAsync()
                        .then(() =>
                        {
                            if (info.callback)
                                info.callback();
                        });
                },
                onUserNotificationButtonClicked: function (evt, eventData)
                {
                    evt.stopPropagation();

                    var
                        buttonTag = eventData.button ? eventData.button.tagGet() : null,
                        userNotificationTag = eventData.notification ? eventData.notification.tagGet() : null;

                    if (!buttonTag || !userNotificationTag)
                        return;

                    seriouslyrad.plugins.notifications.userNotificationManager.dismissNotificationAsync(userNotificationTag.id)
                        .then(() =>
                        {
                            return eventData.notification.removeAsync();
                        })
                        .then(() =>
                        {
                            if (buttonTag === "open")
                            {
                                var
                                    targetUrl = eventData.notification.targetUrlGet();

                                if (targetUrl)
                                    return window.pageManager.navigateAsync(String.format("{0}{1}", window.applicationInformation.virtualDirectory, targetUrl));
                            }
                        });
                }
            };
        }
    });

    // Notification Hub
    classFactory.create({
        namespace: "seriouslyrad.plugins.notifications",
        name: "NotificationHub",
        properties: [
            { name: "authenticated", type: "boolean" },
            { name: "connected", type: "boolean" },
            { name: "connectionStarted", type: "boolean" },
            { name: "engineAvailable", type: "boolean" }
        ],
        createConstructor: namespace =>
        {
            return function ()
            {
                this._bindEvents();
                this.methods = {};

                $$(document).trigger("seriouslyrad.ui.NotificationHub:RegisterMethods", this);
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addMethodToConnection: function (methodName, fn)
                {
                    var
                        self = this;

                    self.connection.on(methodName, (...args) =>
                    {
                        try { fn.apply(self, args); }
                        catch (e) { console.errorAndThrow(e); }
                    });
                },
                _authenticatedChanged: function ()
                {
                    this._updateConnection();
                },
                _bindEvents: function ()
                {
                    $$(document).on("seriouslyrad.ui.Application:Authenticated", { self: this }, this.onAuthenticated);
                    $$(document).on("seriouslyrad.ui.Application:Connected", { self: this }, this.onConnected);
                    $$(document).on("seriouslyrad.ui.Application:Disconnected", { self: this }, this.onDisconnected);
                    $$(document).on("seriouslyrad.ui.Application:Unauthenticated", { self: this }, this.onUnauthenticated);

                    $$(document).on("seriouslyrad.ui.NotificationHub:Connected", { self: this }, this.onNotificationHubConnected);
                    $$(document).on("seriouslyrad.ui.NotificationHub:UserSettingsChanged", { self: this }, this.onNotificationHubUserSettingsChanged);
                },
                _connectedChanged: function ()
                {
                    this._updateConnection();
                },
                _createNewConnection: function ()
                {
                    var
                        self = this,
                        accessTokenFactory;

                    if (window.application.authenticationSchemeGet() === "Bearer")
                    {
                        accessTokenFactory = () =>
                        {
                            return (
                                window.application.webApiClient
                                    .createApiMethodRequest(
                                        "DataService",
                                        "CallDataService",
                                        {
                                            id: "cc235279-29c2-4a76-b08a-71e574e614ee",
                                            operation: "GetSignalRAccessToken"
                                        },
                                        null,
                                        false
                                    )
                                    .executeAsync()
                                    .then(response =>
                                    {
                                        return response ? response.accessToken : null;
                                    })
                            );
                        };
                    }

                    self._destroyConnection();

                    self.connection = new signalR.HubConnectionBuilder()
                        .withUrl(String.format("{0}signalr/hubs", window.applicationInformation.serverVirtualDirectory), {
                            accessTokenFactory: accessTokenFactory
                        })
                        .withAutomaticReconnect()
                        .build();

                    self.connection.onreconnected(connectionId =>
                    {
                        $$(document).trigger("seriouslyrad.ui.NotificationHub:Connected", self);
                    });

                    for (var methodName in self.methods)
                        self._addMethodToConnection(methodName, self.methods[methodName]);
                },
                _destroyConnection: function ()
                {
                    if (!this.connection)
                        return;

                    this.connection.onreconnected(() => { });

                    this.connection = null;
                },
                _engineAvailableChanged: function ()
                {
                    this._updateConnection();
                },
                _ensureConnectionStartedAsync: function ()
                {
                    var
                        self = this;

                    if (self.connectionStartedGet())
                        return;

                    self.connectionStartedSet(true);

                    self._createNewConnection();

                    return (
                        self.connection.start()
                            .then(() =>
                            {
                                $$(document).trigger("seriouslyrad.ui.NotificationHub:Connected", self);
                            })
                    );
                },
                _ensureConnectionStoppedAsync: function ()
                {
                    if (!this.connectionStartedGet())
                        return;

                    this.connectionStartedSet(false);

                    if (!this.connection)
                        return;

                    var
                        stopPromise = this.connection.stop();

                    this._destroyConnection();

                    return stopPromise;
                },
                _loadUserSettings: function ()
                {
                    if (!seriouslyrad.plugins.notifications.userNotificationManager)
                        return;

                    window.application.webApiClient
                        .createEntitySearchRequest("UserSettings", "userSettingType/name eq 'Notification Sounds'")
                        .executeAsync()
                        .then(data =>
                        {
                            seriouslyrad.plugins.notifications.userNotificationManager.notificationSoundsSet(data.length ? data[0].value === "true" : false);
                        });
                },
                _updateConnection: function ()
                {
                    var
                        authenticated = this.authenticatedGet(),
                        connected = this.connectedGet(),
                        engineAvailable = this.engineAvailableGet();

                    if (authenticated && connected && engineAvailable)
                        this._ensureConnectionStartedAsync();
                    else
                        this._ensureConnectionStoppedAsync();
                },

                // Public Methods
                registerMethod: function (name, fn)
                {
                    this.methods[name] = fn;
                },

                // Event Handlers
                onAuthenticated: function (evt)
                {
                    var
                        engines = window.application?.permissionCache?.enginesGet();

                    evt.data.self.authenticatedSet(true);
                    evt.data.self.engineAvailableSet(!!(engines?.notificationEngine));
                },
                onConnected: function (evt)
                {
                    evt.data.self.connectedSet(true);
                },
                onDisconnected: function (evt)
                {
                    evt.data.self.connectedSet(false);
                },
                onUnauthenticated: function (evt)
                {
                    evt.data.self.authenticatedSet(false);
                },

                onNotificationHubConnected: function (evt, notificationHub)
                {
                    seriouslyrad.server.WebApiClient.addStaticHeader("X-SignalRHub-ConnectionId", notificationHub.connection.connectionId);
                },
                onNotificationHubUserSettingsChanged: function (evt)
                {
                    evt.data.self._loadUserSettings();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            $$(document).on("seriouslyrad.ui.NotificationHub:RegisterMethods", (evt, hub) =>
            {
                hub.registerMethod("newUserNotification", userNotification =>
                {
                    if (seriouslyrad.plugins.notifications.userNotificationManager)
                        seriouslyrad.plugins.notifications.userNotificationManager.newNotification(userNotification);
                });

                hub.registerMethod("permissionsChanged", () =>
                {
                    if (window.application?.permissionCache)
                        window.application.permissionCache.refresh();
                });

                hub.registerMethod("userSettingsChanged", () =>
                {
                    $$(document).trigger("seriouslyrad.ui.NotificationHub:UserSettingsChanged");
                });
            });

            $$(() => { seriouslyrad.plugins.notifications.notificationHub = new seriouslyrad.plugins.notifications.NotificationHub(); });
        }
    });

    // User Notification Manager
    classFactory.create({
        namespace: "seriouslyrad.plugins.notifications",
        name: "UserNotificationManager",
        properties: [
            { name: "alertCount", type: "int" },
            { name: "notificationSounds", type: "boolean" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                alertCount: 0,
                notificationSounds: false
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this._initialize();
                this._bindEvents();

                // Trigger Property Changes
                this.alertCountTriggerChange();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _alertCountChanged: function (change)
                {
                    if (this.toolbarButtonAlert)
                    {
                        this.toolbarButtonAlert.alertCountSet(change.currentValue);
                        this.toolbarButtonAlert.showAlertSet(change.currentValue > 0);
                    }

                    if (this.notificationSoundsGet())
                        this.newNotificationAudio.play();
                },
                _alertCountDecrement: function ()
                {
                    var
                        alertCount = this.alertCountGet();

                    this.alertCountSet(alertCount - 1);
                },
                _alertCountIncrement: function ()
                {
                    var
                        alertCount = this.alertCountGet();

                    this.alertCountSet(alertCount + 1);
                },
                _bindEvents: function ()
                {
                    $$(document).on("seriouslyrad.ui.NotificationHub:Connected", { self: this }, this.onNotificationHubConnected);

                    if (seriouslyrad.plugins.notifications.notificationHub.connectedGet())
                        this.onNotificationHubConnected({ data: { self: this } }, seriouslyrad.plugins.notifications.notificationHub);
                },
                _initialize: function ()
                {
                    this.newNotificationAudio = new Audio(String.format("{0}audio/teleporter.mp3", window.applicationInformation.virtualDirectory));
                    this.newNotificationAudio.volume = 0.2;

                    this.userNotificationDialog = new namespace.UserNotificationManager.UserNotificationDialog();
                    this.userNotificationPanel = new namespace.UserNotificationManager.UserNotificationPanel();

                    this.toolbarButtonUserMenuOpen = $$(".rad-action-user-menu-open").radControl();

                    if (this.toolbarButtonUserMenuOpen)
                    {
                        var
                            toolbar = this.toolbarButtonUserMenuOpen.parentControlGet();

                        this.toolbarButtonAlert =
                            new seriouslyrad.ui.web.ToolbarButton({
                                cssClass: "rad-action-user-notification-dialog-open",
                                icon: "alarm"
                            }).appendTo(toolbar);

                        this.toolbarButtonUserMenuOpen
                            .appendTo(toolbar);

                        this.toolbarButtonAlert.on("click", { self: this }, this.onToolbarButtonAlertClicked);
                    }

                    $$(document).triggerHandler("seriouslyrad.ui.UserNotificationManager:Initialized");
                },
                _updateAlertCountAsync: function ()
                {
                    var
                        self = this;

                    return (
                        window.application.webApiClient
                            .createApiMethodRequest(
                                "DataService",
                                "CallDataService",
                                {
                                    id: "cc235279-29c2-4a76-b08a-71e574e614ee",
                                    operation: "GetUserSummary"
                                },
                                null,
                                false
                            )
                            .executeAsync()
                            .then(result =>
                            {
                                self.alertCountSet(result?.unread ? result.unread : 0);
                            })
                    );
                },

                // Public Methods
                alertCountSet: function (value)
                {
                    if (value < 0)
                        value = 0;

                    this._alertCountSet(value);
                },
                dismissNotificationAsync: function (notificationId)
                {
                    var
                        self = this;

                    return (
                        window.application.webApiClient
                            .createApiMethodRequest(
                                "DataService",
                                "CallDataService",
                                {
                                    id: "cc235279-29c2-4a76-b08a-71e574e614ee",
                                    operation: "CloseUserNotification",
                                    data: { id: notificationId }.toJson()
                                },
                                null,
                                false
                            )
                            .executeAsync()
                            .then(() =>
                            {
                                self._alertCountDecrement();
                            })
                    );
                },
                newNotification: function (notification)
                {
                    this._alertCountIncrement();
                    this.userNotificationPanel.addNotification(notification);
                },

                // Event Handlers
                onNotificationHubConnected: function (evt, notificationHub)
                {
                    evt.data.self._updateAlertCountAsync();
                },
                onToolbarButtonAlertClicked: function (evt)
                {
                    var
                        self = evt.data.self;

                    self.userNotificationDialog
                        .openAsync();
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            $$(() =>
            {
                classFactory.create({
                    namespace: classConstructor,
                    name: "UserNotificationDialog",
                    inherits: seriouslyrad.ui.web.Dialog,
                    createPropertyDefaults: namespace =>
                    {
                        return {
                            blockNavigation: false,
                            okButtonText: "Close",
                            scrollable: false,
                            title: "Notifications"
                        };
                    },
                    createConstructor: namespace =>
                    {
                        return function ()
                        {
                            this.addCssClass("rad-control-user-notification-dialog");
                        };
                    },
                    createPrototype: namespace =>
                    {
                        return {
                            // "Protected" Methods
                            _createChildControls: function ()
                            {
                                this.super._createChildControls();

                                var
                                    $$containerElement = this.$$containerElementGet();

                                this.userNotificationList =
                                    new seriouslyrad.plugins.notifications.UserNotificationList({ dialog: this })
                                        .appendTo($$containerElement);
                            },

                            // Public Methods
                            openAsync: function ()
                            {
                                var
                                    self = this;

                                return (
                                    self.userNotificationList.loadDataAsync()
                                        .then(() =>
                                        {
                                            return self.openAsyncSuper();
                                        })
                                );
                            },
                            openAsyncSuper: function ()
                            {
                                return this.super.openAsync();
                            }
                        };
                    }
                });

                classFactory.create({
                    namespace: classConstructor,
                    name: "UserNotificationPanel",
                    inherits: seriouslyrad.ui.web.Panel,
                    createConstructor: namespace =>
                    {
                        return function ()
                        {
                            this.addCssClass("rad-control-user-notification-panel");
                        };
                    },
                    createPrototype: namespace =>
                    {
                        return {
                            // "Protected" Methods
                            _bindEvents: function ()
                            {
                                this.super._bindEvents();

                                this.on("userNotificationButtonClicked", { self: this }, this.onUserNotificationButtonClicked);
                            },
                            _createContainerElement: function ()
                            {
                                var
                                    $$element = this.$$elementGet(),
                                    $$containerElement =
                                        $$.create$$({ nodeName: "div", attributes: { "class": "ui cards" } })
                                            .appendTo($$element);

                                this.$$containerElementSet($$containerElement);
                            },
                            _setCloseTimer: function ()
                            {
                                var
                                    self = this;

                                if (self.closeTimerTimeoutId)
                                {
                                    clearTimeout(self.closeTimerTimeoutId);
                                    self.closeTimerTimeoutId = 0;
                                }

                                if (!self.closeTimerTimeoutId)
                                {
                                    self.closeTimerTimeoutId = setTimeout(() =>
                                    {
                                        self.closeTimerTimeoutId = 0;
                                        self.$$elementGet().transition({
                                            animation: "fly left out",
                                            onComplete: function ()
                                            {
                                                self.controlsClear();
                                            }
                                        });
                                        self.visible = false;
                                    }, 5000);
                                }
                            },

                            // Public Methods
                            addNotification: function (notification)
                            {
                                var
                                    $$element = this.$$elementGet();

                                new seriouslyrad.plugins.notifications.UserNotification({
                                    tag: notification,
                                    targetUrl: notification.targetUrl,
                                    text: notification.message,
                                    title: notification.title,
                                    subtitle: notification.createdDate ? Date.fromString(notification.createdDate, "yyyy-MM-ddTHH:mm:ss.fffffffZ").convertToUTC().toString("dd/MM/yyyy HH:mm:ss") : null
                                }).appendTo(this);

                                $$element[0].scrollTop = $$element[0].scrollHeight;

                                if (!this.visible)
                                {
                                    $$element
                                        .appendTo("body")
                                        .show()
                                        .transition("fly left in");

                                    this.visible = true;
                                }

                                this._setCloseTimer();
                            },

                            // Event Handlers
                            onUserNotificationButtonClicked: function (evt, eventData)
                            {
                                evt.stopPropagation();

                                var
                                    self = evt.data.self,
                                    buttonTag = eventData.button ? eventData.button.tagGet() : null,
                                    userNotificationTag = eventData.notification ? eventData.notification.tagGet() : null;

                                self._setCloseTimer();

                                if (!buttonTag || !userNotificationTag)
                                    return;

                                seriouslyrad.plugins.notifications.userNotificationManager.dismissNotificationAsync(userNotificationTag.id)
                                    .then(() =>
                                    {
                                        return eventData.notification.removeAsync();
                                    })
                                    .then(() =>
                                    {
                                        if (buttonTag === "open")
                                        {
                                            var
                                                targetUrl = eventData.notification.targetUrlGet();

                                            if (targetUrl)
                                                return window.pageManager.navigateAsync(String.format("{0}{1}", window.applicationInformation.virtualDirectory, targetUrl));
                                        }
                                    });
                            }
                        };
                    }
                });

                seriouslyrad.plugins.notifications.userNotificationManager = new seriouslyrad.plugins.notifications.UserNotificationManager();
            });
        }
    });
